import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPage} from '@Components/poster-editor/poster-editor-reducer';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.class';
import {BaseItemMultiplyOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-multiply-option';
import {useAppSelector} from '@/hooks';
import type {RGBA} from '@Utils/color.util';

interface ImageBgMultiplyOptionProps {
  onClickColorFill(): void;
}

export function ImageBgMultiplyOption({...props}: ImageBgMultiplyOptionProps): ReactElement<any> | null {
  const currentPageObject = useAppSelector(getCurrentPage);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageObject) {
    return null;
  }

  if (currentPageObject.background.details.type !== BackgroundTypeName.IMAGE) {
    return null;
  }

  const onClickColorFill = (): void => {
    props.onClickColorFill();
  };

  const onToggleMultiply = (): void => {
    if ('imageBackgroundItemObject' in currentPageObject.background.details) {
      void currentPage?.background.updateFromObject({
        details: {
          imageBackgroundItemObject: {
            effects: {
              multiply: !currentPageObject.background.details.imageBackgroundItemObject.effects.multiply,
            },
          },
        },
      });
    } else {
      throw new Error('imageBackgroundItemObject does not exist in page background details');
    }
  };

  const onUpdateOpacity = (multiplyOpacity: number, undoable = true): void => {
    if ('imageBackgroundItemObject' in currentPageObject.background.details) {
      const multiplyColor = currentPageObject.background.details.imageBackgroundItemObject.effects.multiplyColor.slice() as RGBA;
      multiplyColor[3] = multiplyOpacity;
      void currentPage?.background.updateFromObject(
        {
          details: {
            imageBackgroundItemObject: {
              effects: {
                multiplyColor,
              },
            },
          },
        },
        {undoable}
      );
    } else {
      throw new Error('imageBackgroundItemObject does not exist in page background details');
    }
  };

  return (
    <BaseItemMultiplyOption
      onClickColorFill={onClickColorFill}
      multiplyOpacity={currentPageObject.background.details.imageBackgroundItemObject.effects.multiplyColor[3]}
      multiply={currentPageObject.background.details.imageBackgroundItemObject.effects.multiply}
      multiplyColor={currentPageObject.background.details.imageBackgroundItemObject.effects.multiplyColor}
      onToggleMultiply={onToggleMultiply}
      updateOpacity={onUpdateOpacity}
    />
  );
}
